export default "__VITE_PUBLIC_ASSET__17ac67aa__"